import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 md:grid-cols-3" }
const _hoisted_2 = { class: "rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-sm" }
const _hoisted_3 = { class: "text-xs font-semibold uppercase tracking-wider text-[#626468]" }
const _hoisted_4 = { class: "mt-2 text-2xl font-bold text-[#242B59]" }
const _hoisted_5 = { class: "rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-sm" }
const _hoisted_6 = { class: "text-xs font-semibold uppercase tracking-wider text-[#626468]" }
const _hoisted_7 = { class: "mt-2 text-2xl font-bold text-[#242B59]" }
const _hoisted_8 = { class: "rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-sm" }
const _hoisted_9 = { class: "text-xs font-semibold uppercase tracking-wider text-[#626468]" }
const _hoisted_10 = { class: "mt-2 text-2xl font-bold text-[#242B59]" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsSummary',
  props: {
    totalCost: {},
    totalItems: {},
    totalTokens: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('aura.processingCosts.summary.totalCost')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.totalCost), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('aura.processingCosts.summary.totalItems')), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.totalItems), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('aura.processingCosts.summary.totalTokens')), 1),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.totalTokens), 1)
    ])
  ]))
}
}

})